import React from 'react';
import styles from './Checkbox.module.scss';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const Checkbox = ({ onClick, checked, className, list }) => {
  const { t } = useTranslation();

  const ref = useAccessibleClick(onClick);

  return (
    <div
      ref={ref}
      tabIndex={0}
      className={className || styles.checkbox}
      onClick={onClick}
      role="checkbox"
      aria-checked={checked}
      aria-label={checked ? t('accessibility.unselect') : t('general.select')}
    >
      {list ? (
        <div className={checked ? styles.listIndicator : ''}>{checked ? <Icon src="vector" /> : null}</div>
      ) : (
        <div className={checked ? styles.indicator : styles.border}>{checked ? <Icon src="vector" /> : null}</div>
      )}
    </div>
  );
};

export default Checkbox;
